import {Component, ViewEncapsulation} from '@angular/core';
import {LoaderService} from './loader.service';

@Component({
    selector: 'dipse-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class LoaderComponent {

  readonly dipseLoaderState$;

  constructor(private dipseLoaderService: LoaderService) {
    this.dipseLoaderState$ = dipseLoaderService.state$;
  }
}
